import {IStore} from "modules/types/store";
import {createSelector} from "reselect";
import {IUser} from "modules/reducers";

export const getUser = (state: IStore) => state.user.user;
export const getUserSupportedCountry = createSelector(
	getUser,
	(user: IUser) => user.supportedCountry
);

export const isLoggedIn = (state: IStore) => state.user.is_authenticated;
export const isPreRegistered = (state: IStore) => state.user.is_preregistered;
